// RB Header — interaction logic. Loaded once per page.

(function(){
  'use strict';
  var root = document.querySelector('.rb-header');
  if (!root) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 1025px)');

  /* ---------------------------------------------------------------------
     1. STICKY HEADER — krimpt subtiel bij scroll
     ---------------------------------------------------------------------- */
  // Sticky-shrink: CSS handles position:sticky via [data-sticky="true"].
  // Hier alleen een class toggle voor de subtle "shrunk" stijl bij scroll.
  if (root.dataset.sticky === 'true') {
    var ticking = false;
    function onScroll(){
      if (!ticking) {
        window.requestAnimationFrame(function(){
          var y = window.scrollY || window.pageYOffset;
          root.classList.toggle('is-sticky', y > 80);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     2. MEGA MENU — hover + intent-buffer + toetsenbord
     --------------------------------------------------------------------- */
  var navItems = root.querySelectorAll('[data-nav-item]');
  var openDelay = 80;   // ms — voorkomt flikker bij snel passeren
  var closeDelay = 200; // ms — "safe-triangle"-buffer

  navItems.forEach(function(item){
    var link = item.querySelector('[data-nav-link]');
    var panel = item.querySelector('[data-mega], .rb-dropdown');
    if (!panel || !link) return;

    var openTimer = null, closeTimer = null;

    function open(){
      clearTimeout(closeTimer);
      if (item.classList.contains('is-open')) return;
      // sluit andere open items
      navItems.forEach(function(other){
        if (other !== item) closeImmediate(other);
      });
      item.classList.add('is-open');
      link.setAttribute('aria-expanded', 'true');
      if (panel.classList.contains('rb-mega')) panel.classList.add('is-open');
    }
    function close(){
      item.classList.remove('is-open');
      link.setAttribute('aria-expanded', 'false');
      if (panel.classList.contains('rb-mega')) panel.classList.remove('is-open');
    }
    function closeImmediate(el){
      var l = el.querySelector('[data-nav-link]');
      var p = el.querySelector('[data-mega], .rb-dropdown');
      el.classList.remove('is-open');
      if (l) l.setAttribute('aria-expanded', 'false');
      if (p && p.classList.contains('rb-mega')) p.classList.remove('is-open');
    }

    // Desktop hover
    item.addEventListener('mouseenter', function(){
      if (!mqDesktop.matches) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, openDelay);
    });
    item.addEventListener('mouseleave', function(){
      if (!mqDesktop.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, closeDelay);
    });

    // Toetsenbord-toegang
    link.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        if (panel) { e.preventDefault(); open(); var first = panel.querySelector('a'); if (first) first.focus(); }
      } else if (e.key === 'Escape') {
        close(); link.focus();
      }
    });
    panel.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { close(); link.focus(); }
    });

    // Sluit bij focus naar buiten
    item.addEventListener('focusout', function(e){
      if (!item.contains(e.relatedTarget)) close();
    });
  });

  // Klik buiten: sluit alle mega's
  document.addEventListener('click', function(e){
    if (!root.contains(e.target)) {
      navItems.forEach(function(item){
        var l = item.querySelector('[data-nav-link]');
        var p = item.querySelector('[data-mega], .rb-dropdown');
        item.classList.remove('is-open');
        if (l) l.setAttribute('aria-expanded','false');
        if (p && p.classList.contains('rb-mega')) p.classList.remove('is-open');
      });
    }
  });

  /* ---------------------------------------------------------------------
     3. ZOEKEN — inline expand
     --------------------------------------------------------------------- */
  var searchWrap = root.querySelector('[data-search]');
  if (searchWrap) {
    var btn = searchWrap.querySelector('[data-search-toggle]');
    var input = searchWrap.querySelector('input[type=search]');
    btn.addEventListener('click', function(){
      var open = searchWrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function(){ input.focus(); }, 50);
    });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { searchWrap.classList.remove('is-open'); btn.focus(); }
    });
    document.addEventListener('click', function(e){
      if (!searchWrap.contains(e.target)) searchWrap.classList.remove('is-open');
    });
  }

  /* ---------------------------------------------------------------------
     4. MOBIELE DRAWER — open/sluit + scroll-lock + focus-trap
     --------------------------------------------------------------------- */
  var drawer = root.querySelector('[data-drawer]');
  var drawerOpenBtn = root.querySelector('[data-drawer-open]');
  var drawerCloseBtn = root.querySelector('[data-drawer-close]');
  var lastFocused = null;

  function trapFocus(e){
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var focusables = drawer.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length-1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer(){
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawerOpenBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('rb-noscroll');
    setTimeout(function(){
      var firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }, 60);
    document.addEventListener('keydown', onDrawerKeydown);
  }
  function closeDrawer(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawerOpenBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('rb-noscroll');
    document.removeEventListener('keydown', onDrawerKeydown);
    if (lastFocused) lastFocused.focus();
  }
  function onDrawerKeydown(e){
    if (e.key === 'Escape') closeDrawer();
    trapFocus(e);
  }

  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', openDrawer);
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if (drawer) drawer.addEventListener('click', function(e){
    if (e.target === drawer) closeDrawer();
  });

  // Drawer accordions
  var drawerItems = drawer ? drawer.querySelectorAll('[data-drawer-item]') : [];
  drawerItems.forEach(function(it){
    var tog = it.querySelector('.rb-drawer-toggle');
    if (!tog || tog.tagName !== 'BUTTON') return;
    tog.addEventListener('click', function(){
      var open = it.classList.toggle('is-open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------------------------------------------------------------------
     5. OPEN/GESLOTEN-INDICATOR — leest hours JSON en bepaalt status
        Formaat per dag: "HH:MM-HH:MM" of leeg (= gesloten).
        Meerdere blokken kan ook: "09:30-12:30,13:30-18:00".
     --------------------------------------------------------------------- */
  var hoursEl = root.querySelector('[data-rb-hours]');
  var openStateEl = root.querySelector('[data-open-state]');
  if (hoursEl && openStateEl) {
    try {
      var cfg = JSON.parse(hoursEl.textContent);
      function update(){
        var now = new Date();
        var day = now.getDay(); // 0=zo
        var todayStr = (cfg.hours[String(day)] || '').trim();
        var nowMin = now.getHours()*60 + now.getMinutes();
        var isOpen = false, closesAt = null;
        if (todayStr) {
          todayStr.split(',').forEach(function(range){
            var m = range.trim().match(/^(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
            if (!m) return;
            var start = parseInt(m[1],10)*60 + parseInt(m[2],10);
            var end   = parseInt(m[3],10)*60 + parseInt(m[4],10);
            if (nowMin >= start && nowMin < end) { isOpen = true; closesAt = m[3]+':'+m[4]; }
          });
        }
        var textEl = openStateEl.querySelector('.rb-open-text');
        openStateEl.setAttribute('data-state', isOpen ? 'open' : 'closed');
        if (isOpen) textEl.textContent = cfg.labels.open + ' · ' + cfg.labels.until + ' ' + closesAt;
        else textEl.textContent = cfg.labels.closed;
      }
      update();
      // ververs elke minuut
      setInterval(update, 60*1000);
    } catch(err){ /* stilletjes laten */ }
  }

  /* ---------------------------------------------------------------------
     6. WINKELWAGEN-COUNT live bijwerken bij ajax cart-events
     --------------------------------------------------------------------- */
  document.addEventListener('cart:updated', function(e){
    var c = e.detail && e.detail.cart;
    if (!c) return;
    var el = root.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = c.item_count;
    el.hidden = c.item_count === 0;
  });
})();


/* ---------- Brand-grid hover-swap ---------- */
(function(){
  function initBrandGrids(){
    document.querySelectorAll('[data-brand-list]').forEach(function(list){
      var mega = list.closest('.rb-mega');
      if(!mega) return;
      var promo = mega.querySelector('[data-brand-promo]');
      if(!promo) return;
      var img = promo.querySelector('img');
      var heading = promo.querySelector('[data-brand-promo-heading]');
      var text = promo.querySelector('[data-brand-promo-text]');
      var ctaWrap = promo.querySelector('[data-brand-promo-cta]');
      var defaultState = {
        href: promo.getAttribute('href') || '#',
        imgSrc: img ? img.getAttribute('src') : '',
        heading: heading ? heading.textContent : '',
        text: text ? text.textContent : ''
      };
      var swapTimer;
      function swap(a){
        list.querySelectorAll('a.is-hovered').forEach(function(x){ x.classList.remove('is-hovered'); });
        a && a.classList.add('is-hovered');
        clearTimeout(swapTimer);
        promo.classList.add('is-swapping');
        swapTimer = setTimeout(function(){
          var src = a ? a.getAttribute('data-brand-image') : defaultState.imgSrc;
          var h = a ? a.getAttribute('data-brand-heading') : defaultState.heading;
          var t = a ? a.getAttribute('data-brand-text') : defaultState.text;
          var u = a ? a.getAttribute('href') : defaultState.href;
          if(img && src) img.src = src;
          if(heading) heading.textContent = h || defaultState.heading;
          if(text) text.textContent = t || defaultState.text;
          if(u) promo.setAttribute('href', u);
          requestAnimationFrame(function(){ promo.classList.remove('is-swapping'); });
        }, 120);
      }
      list.querySelectorAll('a[data-brand-image]').forEach(function(a){
        a.addEventListener('mouseenter', function(){ swap(a); });
        a.addEventListener('focus', function(){ swap(a); });
      });
    });
  }
  if(document.readyState !== 'loading') initBrandGrids();
  else document.addEventListener('DOMContentLoaded', initBrandGrids);
})();

